import { Response } from 'app/core/models/base/response'

export const CommonResponse: <T>(response: Response<T>, meta: any) => T = <T>(
    response: Response<T>,
    meta: any
) => {
    return response
}
